import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

const ProgramsPage = lazyRouteComponent(() => import('src/pages/apps'));

/**
 * Programs listing. Path: /programs
 * (DashboardLayout + AuthGuard come from the _protected layout.)
 */
export const Route = createFileRoute('/_protected/programs/')({
  component: ProgramsPage,
});
